import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { ICheckoutState, ICheckoutRedirect } from '../type';
import { AppDispatch } from 'stores';
import { getCheckoutRedirectUrl } from 'helpers/api';
import { EActionType } from 'modules/ProductManagement/type';

export const initialState: ICheckoutState = {
    isLoading: false,
    isError: false,
    error: null,
};

const slice: Slice<ICheckoutState> = createSlice({
    name: 'checkout',
    initialState,
    reducers: {
        fetchRequested: state => ({
            ...state,
            isLoading: true,
            isError: false,
            error: null,
        }),
        fetchSucceeded: (state, action: PayloadAction<ICheckoutRedirect>) => {
            window.location.assign(action.payload.redirectUrl);

            return {
                ...state,
                isLoading: false,
                isError: false,
                error: null,
            };
        },
        fetchFailed: (state, action: PayloadAction<AxiosError>) => ({
            ...state,
            isLoading: false,
            isError: true,
            error: {
                status: action.payload?.response?.status,
                message: action.payload?.response?.data.message,
            },
        }),
    },
});

export const { fetchRequested, fetchSucceeded, fetchFailed } = slice.actions;

export const fetchCheckoutRedirectUrl = (action: EActionType) => {
    return (dispatch: AppDispatch) => {
        dispatch(fetchRequested(undefined));

        return getCheckoutRedirectUrl(action, window.location.href)
            .then(res => {
                dispatch(fetchSucceeded(res.data));
            })
            .catch(err => {
                dispatch(fetchFailed(err));
            });
    };
};

export default slice.reducer;
